module.exports = __webpack_public_path__ + "img/checkOff.168fd816.svg";